import { Box } from '@mui/material';
import styled, { keyframes } from 'styled-components';
import { rgbaOrange } from 'constants/colors';

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 1px 0 ${rgbaOrange(0.5)};
  }
  50% {
    box-shadow: 0 0 8px 0 ${rgbaOrange(0.8)};
  }
  100% {
    box-shadow: 0 0 1px 0 ${rgbaOrange(0.5)};
  }
`;

const fadeOutOutline = keyframes`
  0% {
    outline-color: ${rgbaOrange(0.8)};
  }
  100% {
    outline-color: transparent;
  }
`;

// Styled component for the highlight effect
export const HighlightedRoute = styled(Box)`
  &.highlighted {
    outline: 1px solid ${rgbaOrange(1)};
    border-radius: 8px;
    animation:
      ${pulseAnimation} 3s ease-in-out,
      ${fadeOutOutline} 0.5s ease-in-out 3s forwards; /* Delayed fade-out */
    }
  }
`;
